import type { FaireProductEntity } from "../../entity_types/product";

export const p_d77t968g3r: FaireProductEntity = {
  token: "p_d77t968g3r",
  type: "product",
  name: "Natural Bamboo Soap Bar Dish. Eco-Friendly",
  brandToken: "b_ttb2n52ngz",
  brandName: "BeNat",
  imageUrl:
    "https://cdn.faire.com/fastly/60547764529a7b44809c1788c548fc6cdcd75733a304c9cd04d6c6eaa54acba8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e797c5fee0ac024a27f2126549cbf404ab5472af9212cf5634770f06e12e08f9.jpeg",
    "https://cdn.faire.com/fastly/e82ea0447d522b9c32d5f79f30000e4ffcf11d5cdcf7f1ee42d0105eee34c267.jpeg",
    "https://cdn.faire.com/fastly/4a4881992e456f28a838e9e20d786c4ca452536cd4a2fc9e7802f890b922754e.jpeg",
    "https://cdn.faire.com/fastly/98f27df9d0c6f467cce9dfea5a4ba7346f3bbaedeb8d73384209217d7adab53d.webp",
    "https://cdn.faire.com/fastly/255650aee8a7477da94687704d397e206a7a9869f0e3319865c1befda7687ea0.webp",
    "https://cdn.faire.com/fastly/6555e187a1d8653532d68fc692ac5bd5e07cf8bcd7fe69315b74a2d45373577c.jpeg",
    "https://cdn.faire.com/fastly/5823ad45d40e8abd59fcf357c65950516b6b69f9203807cfb70d8c70dbebf5f6.jpeg",
    "https://cdn.faire.com/fastly/8c9cc78620b7c0b9a8c143c1476da0beefac04339539bea04052d86658c43d6a.png",
  ],
  priceDollars: 2.54,
  description:
    "Contribute to saving the planet from plastic pollution with our plastic-free shampoo and conditioner bar, and to keep them in optimal condition, use our shampoo bar dish.\n\nThe exquisite and simple design has the perfect size to hold your BeNat shampoo and conditioner bar and not take up much space in your shower. Keeps your shampoo bar, conditioner bar, or soap bar drying, clean, and well-ventilated, saved from rotting, gushy, and messy.\n\nSave your bar and keep it dry.\nFeatures & Details:\nNatural Bamboo Tray\n4.5 x 0.7 x 3.5 inches\n\n**Clean it with soapy water and dry it with a cloth every 2 weeks to keep it mold-free.",
  tags: [],
  msrpDollars: 5.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:50.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
